import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { RentalFilesField } from "./rentals/RentalFiles";

const linkify = (t) => t.split(/(https?:\/\/\S+)/g).map((p, i) => (/^https?:\/\//.test(p)
  ? <a key={i} href={p} target="_blank" rel="noreferrer" className="text-blue-600 underline">{p}</a> : p));

export const InfoNotesPage = ({ page, canEdit, onSave }) => {
  const [content, setContent] = useState(page.content || "");
  const [atts, setAtts] = useState(page.attachments || []);
  const [edit, setEdit] = useState(canEdit && !page.content);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { await onSave({ ...page, content, attachments: atts }); setEdit(false); toast.success("تم الحفظ"); }
    catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الحفظ"); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-3 rounded-2xl border border-slate-200 bg-white p-4" data-testid={`info-notes-${page.id}`}>
      {edit ? <Textarea rows={10} value={content} onChange={(e) => setContent(e.target.value)} placeholder="اكتب المعلومات هنا… (الروابط تصبح قابلة للضغط)" data-testid="info-notes-text" />
        : <div className="whitespace-pre-wrap text-sm leading-7 text-slate-700">{content ? linkify(content) : <span className="text-slate-400">لا يوجد محتوى</span>}</div>}
      {canEdit ? <RentalFilesField value={atts} onChange={setAtts} testid="info-notes-files" />
        : atts.length > 0 && <RentalFilesField value={atts} onChange={() => {}} testid="info-notes-files" />}
      {canEdit && (
        <div className="flex gap-2">
          {!edit && <Button size="sm" variant="outline" onClick={() => setEdit(true)} data-testid="info-notes-edit">تعديل النص</Button>}
          <Button size="sm" className="mr-auto gap-1" disabled={busy} onClick={save} data-testid="info-notes-save">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} حفظ</Button>
        </div>
      )}
    </div>
  );
};
